/**
 * Table Record Deletion
 * Trash icon used by some tables to delete record
 */
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { ConfirmationDialog } from '@components/ConfirmationDialog';
import Icon from '@components/Icon/Icon';
import {
  ButtonImage,
  ButtonImageContainer,
} from '@components/SideStripDesktop/SideButton.style';

const messages = defineMessages({
  deleteConfirm: {
    id: 'tableRecordDeletion.deleteConfirm',
    defaultMessage: 'Are you sure you want to delete this task?',
  },
  deleteConfirmation: {
    id: 'GLOBAL.deleteConfirmation',
    defaultMessage: 'To confirm deletion, type {phrase} in the field.',
  },
  deletePhrase: {
    id: 'confirmation.deletePhrase',
    defaultMessage: 'DELETE',
  },
});

export const TableRecordDeletion: React.FC<{
  onDelete: () => Promise<void>;
  loading: boolean;
}> = ({ onDelete: handleDelete, loading }) => {
  const { formatMessage } = useIntl();

  return (
    <ConfirmationDialog
      challenge={{
        description: formatMessage(messages.deleteConfirmation, {
          phrase: formatMessage(messages.deletePhrase),
        }),
        phrase: formatMessage(messages.deletePhrase),
      }}
      onConfirm={handleDelete}
      title={formatMessage(messages.deleteConfirm)}
    >
      {({ handleOpen }) => (
        <ButtonImageContainer
          bottom={false}
          onClick={(e) => {
            e.stopPropagation();
            handleOpen();
          }}
          type="submit"
        >
          <ButtonImage bottom={false} highlighted={false}>
            <Icon
              clickable
              color={loading ? 'divider' : 'error.main'}
              name={loading ? 'loader' : 'trash'}
              size="xs"
              type="fas"
            />
          </ButtonImage>
        </ButtonImageContainer>
      )}
    </ConfirmationDialog>
  );
};
